import React, { useContext } from "react";
import Modal from "shared/components/Modal";

import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { Image } from "@nykaa/payment-ui/src/Image";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { useTheme } from "emotion-theming";
import { FilledButton, TextButton } from "@nykaa/payment-ui/src/Button";


const ErrorModal = () => {
  const errorModalContext = useContext(ErrorModalContext);
  const theme = useTheme() as Theme;
  const closeErrorModal = errorModalContext?.closeErrorModal;
  const closeFromSecondaryButton = errorModalContext?.closeFromSecondaryButton;
  const {
    isOpen,
    title,
    message,
    primaryButtonText,
    secondaryButtonText,
  } = errorModalContext?.error;

  if (isOpen) {
    return (
      <Modal
        isVisible={isOpen}
        onHide={closeErrorModal}
        zIndex={3}
        zIndexOverlay={2}
        isPartial
        modalContentClass="pt10 prl10 error-modal"
      >
        <div className="ptb10 text-center server-error-popup">
          <i className="mb10 icon">
            <Image url={getIcons(__PLATFORM__, ICONS_NAMES.ALERT)} alt={"error"} theme={theme} />
          </i>
          <p className="mb0 font-semibold font-size-16" role="heading" aria-level={2}>{title}</p>
          <p className="m0 ptb10 prl10 font-size-12 error-msg">{message}</p>
          <FilledButton
            text={primaryButtonText || "Close"}
            font={theme.typography.buttonSmall}
            color={theme.colors.surface}
            onClick={closeErrorModal}
            theme={theme}
          />
          {secondaryButtonText && (
            <TextButton
              text={secondaryButtonText}
              font={theme?.typography.buttonMedium}
              color={theme?.colors.primary}
              onClick={closeFromSecondaryButton}
            />
          )}
        </div>
      </Modal>
    );
  }
  return null;
};

export default ErrorModal;
